import React, { useState, useEffect } from 'react';

import { ExpandingListItemHeader, ExpandIcon, ApiDescription, APIAndDescriptionContainer } from './styles';

export default function ApiMethod({ apiMethod }) {
  const [canOpen, setCanOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => setCanOpen(!!apiMethod?.description || !!apiMethod?.challengeDescription), [apiMethod, setCanOpen]);

  return (
    <APIAndDescriptionContainer>
      <ExpandingListItemHeader isOpen={isOpen} canOpen={canOpen} onClick={() => setIsOpen(canOpen && !isOpen)}>
        {apiMethod.header}
        {canOpen && <ExpandIcon icon={isOpen ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} />}
      </ExpandingListItemHeader>
      {isOpen && (
        <>
          <ApiDescription>{apiMethod.description}</ApiDescription>
          {apiMethod.challengeDescription && <ApiDescription>{apiMethod.challengeDescription}</ApiDescription>}
        </>
      )}
    </APIAndDescriptionContainer>
  );
}
